var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { decryptFileWithDecipherStream } from '../CryptoUtils';
import { asyncFetch } from '../NetworkUtils';
const WrapperLink = styled.a `
  text-decoration: none;
`;
const FileContainer = styled.div `
  min-width: 172px;
  max-width: 172px;
  position: relative;
  left: 2.5rem;
  width: fit-content;
  background-color: #1D1D21;
  &:hover {
    background-color: #2a2b37;
  }
  display: flex;
  gap: 4px;,
  border-radius: 2px;
  padding: 4px;
  cursor: poiner;
`;
const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4E95FF;
  border-radius: 2px;
  width: 2rem;
  height: 2rem;
  padding: 0.5rem:
`;
const FileInfo = styled.div `
  display: flex;
  flex-direction: column;
`;
const FileTitle = styled.div `
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 130px;
  -webkit-font-smoothing: antialiased applied;
`;
const FileExtension = styled.div `
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  color: #5c5c71;
`;
const FileIcon = ({ className }) => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", fill: "white", className: className !== null && className !== void 0 ? className : 'bi bi-file-earmark-fill', viewBox: "0 0 16 16" }, { children: _jsx("path", { d: "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" }) })));
const MessageFileField = ({ files, encryptionKey, nonce, authToken, privateIpfsEndpoint }) => {
    var _a;
    if (!(files === null || files === void 0 ? void 0 : files.length))
        return null;
    const mainFile = files[0];
    const fileName = mainFile === null || mainFile === void 0 ? void 0 : mainFile.name;
    const [dataUrl, setDecryptedFile] = useState();
    useEffect(() => {
        const encrypted = mainFile.ipfs_cid.startsWith('encrypted_');
        if (encrypted) {
            const cid = mainFile.ipfs_cid.slice('encrypted_'.length);
            asyncFetch(`${privateIpfsEndpoint}/${cid}`, {
                method: 'GET',
                headers: Object.assign({}, (authToken ? { 'x-api-key': authToken } : {})),
            }).then((res) => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                if (res.status === 500) {
                    setDecryptedFile(undefined);
                    return;
                }
                else {
                    const extension = (_a = mainFile.name) === null || _a === void 0 ? void 0 : _a.split('.').pop();
                    let blob = yield decryptFileWithDecipherStream(encryptionKey, nonce, res.body);
                    blob = new Blob([blob], { type: `image/${extension}` });
                    const objectUrl = URL.createObjectURL(blob);
                    setDecryptedFile(objectUrl);
                }
            }));
        }
        else {
            setDecryptedFile(mainFile.ipfs_cid);
        }
        // Clean up the URL when the component is unmounted
        return () => {
            if (dataUrl) {
                URL.revokeObjectURL(dataUrl);
            }
        };
    }, []);
    return (_jsx(WrapperLink, Object.assign({ href: dataUrl, target: "_blank", download: fileName }, { children: _jsxs(FileContainer, { children: [_jsx(IconContainer, { children: _jsx(FileIcon, { className: "bi bi-file-earmark-fill" }) }), fileName && (_jsxs(FileInfo, { children: [_jsx(FileTitle, { children: fileName }), _jsx(FileExtension, { children: (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toUpperCase() })] }))] }) })));
};
export default MessageFileField;
